/**
 * Collection of validation messages
 * Messages object can be imported into files where form validation is needed
 * We can then iterate through the keys in the messages object to get the error message
 * This object allows us to reuse validation messages and reduce the amount of repetitive code
 *
 * Important Caveat - at the present time, message text cannot be dynamically updated
 * If dynamic text is necessary, messages object can be expanded on in the given component
 */

export default class ValidationReporting {
    constructor()
    {
        /** Default validation messages */
        this.default = {
            required: {
                input: 'This field is required.',
                select: 'Please select an option.',
                multi_select: 'You must select at least one of the options.',
                date: {
                    from: 'Start date is required.',
                    to: 'End date is required.',
                },
            },
            email: 'Please enter valid email.',
            url: 'This field must be a url.',
            integer: 'This field must be a whole number.',
            numeric: 'This field must be numeric.',
        };

        /** Form field with validator messages */
        this.messages = {
            first_name: {
                required: this.default.required.input,
            },
            last_name: {
                required: this.default.required.input,
            },
            email: {
                required: this.default.required.input,
                email: this.default.email,
            },
            phone: {
                required: this.default.required.input,
            },
            address_line_one: {
                required: this.default.required.input,
            },
            address_line_two: {},
            town_or_city: {
                required: this.default.required.input,
            },
            post_code: {
                required: this.default.required.input,
            },
            country: {
                required: this.default.required.select,
            },
        };
    }

    /**
     * Field under validation, validation parameter
     * Return validation error message
     */
    get(key, param)
    {
        return this.messages[key][param];
    }
}
